(()=>{
'use strict';
if(window.AWP27ModelContext?.version)return;
const VERSION='2.7.3';
const parse=v=>{try{return JSON.parse(v||'[]')}catch(_){return[]}};
function run(){
  const engine=window.AWTechnicalIntelligenceP27;if(!engine)return false;
  document.querySelectorAll('[data-aw-p1-model-graph]').forEach(root=>{
    const node=root.querySelector('[data-aw-p27-model-profile]');if(!node||node.dataset.awP27Ready==='true')return;
    const profile=engine.buildProfile(parse(node.textContent));
    const context={
      version:VERSION,
      modelHandle:root.dataset.awModel||'',
      profile,
      guide:engine.guideContext(profile),
      atelier:engine.atelierChecklist(profile),
      customer:engine.customerContext(profile),
      diagnostics:engine.diagnostics(profile),
      recommendation:engine.recommendationContext(profile),
      atelierBrief:engine.atelierBrief(profile)
    };
    root.querySelectorAll('[data-aw-p1-track="model_graph_guide"]').forEach(a=>a.dataset.awP27Context='technical-guide');
    root.querySelectorAll('[data-aw-p1-track="model_graph_atelier"]').forEach(a=>a.dataset.awP27Context='technical-atelier');
    node.dataset.awP27Ready='true';
    window.AWP27CurrentModelContext=context;
    window.dispatchEvent(new CustomEvent('aw:p27:model-context-ready',{detail:{version:VERSION,modelHandle:context.modelHandle,verifiedFacts:profile.verified.length,documentedFacts:profile.documented.length}}));
    try{window.AWAnalytics?.track?.('p27_model_context_ready',{version:VERSION,model_handle:context.modelHandle,verified:profile.verified.length,documented:profile.documented.length,conflicts:profile.conflicts.length})}catch(_){}
  });
  return true;
}
const boot=()=>{if(!run())window.addEventListener('aw:p27:technical-intelligence-ready',run,{once:true})};
document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot,{once:true}):boot();
document.addEventListener('shopify:section:load',boot);
window.AWP27ModelContext={version:VERSION,run,policy:'canonical model facts; read-only contexts; no compatibility inference'};
})();